import type { OptOutApi } from "../../api/OptOutApi";
import type { OptOutGroupStatus } from "../../generated/dto/OptOutGroupStatus";
import type { OptOutSetMemberOptOutRequest } from "../../generated/dto/OptOutSetMemberOptOutRequest";
import type { OptOutStatus } from "../../generated/dto/OptOutStatus";
import type { OptOutUpdateOptOutTokenRequest } from "../../generated/dto/OptOutUpdateOptOutTokenRequest";

export class OptOutFrontendService {
  constructor(private readonly api: OptOutApi) {}
  async memberOptOutStatusMember(): Promise<OptOutStatus> {
    return this.api.memberOptOutStatusMember()
  }
  async setMemberOptOutMember(request: OptOutSetMemberOptOutRequest): Promise<OptOutStatus> {
    return this.api.setMemberOptOutMember(request)
  }
  async updateOptOutTokenPublic(request: OptOutUpdateOptOutTokenRequest): Promise<OptOutGroupStatus> {
    return this.api.updateOptOutTokenPublic(request)
  }
}
